import React, {useCallback} from "react";
import initialMetricsPublisher from "../../metrics";
import Row from "@amzn/meridian/row";
import {VISSDashboard} from "src/components/vendorIdentity/VISSDashboard";


export class VendorIdentityRoot extends React.Component {

    componentDidMount() {
        const actionMetricsPublisher =
            initialMetricsPublisher.newChildActionPublisherForMethod("PageLoad");
        actionMetricsPublisher.publishCounterMonitor('vendor-identity-page-load', 1);
    }

    render() {
        return (
            <Row width="100%" widths={["grid-12"]}>
                <VISSDashboard/>
            </Row>
        );
    }
}

export default VendorIdentityRoot;